import $ from 'jquery';
import {debounce, throttle} from '@exadel/esl/modules/esl-utils/async';
import {sequentialUID} from '@exadel/esl/modules/esl-utils/misc/uid';
import {DEFAULT_BP_QUERY} from 'core/helpers/breakpoints';

import type {View, EventCallback} from 'core/view';

const $window = $(window);

const WINDOW_ON_RESIZE_DELAY = 200;
const onResizeCallbacks = $.Callbacks();
$window.on('resize', debounce(onResizeCallbacks.fire, WINDOW_ON_RESIZE_DELAY));

const WINDOW_ON_SCROLL_THROTTLE = 50;
const onScrollCallbacks = $.Callbacks();
$window.on('scroll', throttle(onScrollCallbacks.fire, WINDOW_ON_SCROLL_THROTTLE));

const onWindowEvent = (event: string, callback: (event: JQuery.Event) => void) => {
  $window.on(event, callback);
  return () => $window.off(event, callback);
};

export const windowHook = (event: string, callback: EventCallback, view: View): () => void => {
  switch (event) {
    case 'resize':
      onResizeCallbacks.add(callback);
      return () => onResizeCallbacks.remove(callback);
    case 'scroll':
      onScrollCallbacks.add(callback);
      return () => onScrollCallbacks.remove(callback);
    case 'fonts.loaded':
      if (document.fonts.status === 'loaded') {
        setTimeout(callback, 1);
        return () => void 0;
      }
      $(document.fonts).on('loadingdone', callback);
      return () => void 0;
    case 'breakpointchange': {
      const bpChangeCallback = () => callback(DEFAULT_BP_QUERY.value);
      setTimeout(bpChangeCallback, 1);
      DEFAULT_BP_QUERY.addEventListener(bpChangeCallback);
      return () => DEFAULT_BP_QUERY.removeEventListener(bpChangeCallback);
    }
    default:
      event += `.${view.cid}.${sequentialUID('we')}`;
      return onWindowEvent(event, callback);
  }
};
